(function () {
  function initFormValidation() {
    var form = document.querySelector('.contact-card__form form');
    if (!form) return;

    form.setAttribute('novalidate', 'true');

    var nameInput = form.querySelector('#ContactFormName');
    var emailInput = form.querySelector('#ContactFormEmail');
    var phoneInput = form.querySelector('#ContactFormPhone');
    var messageInput = form.querySelector('#ContactFormMessage');

    var formSubmitted = false;

    function showError(input, message) {
      if (!input) return;
      var group = input.closest('.form-field-group');
      if (!group) return;
      var errorSpan = group.querySelector('.form-field-error');
      input.classList.add('is-invalid');
      group.classList.add('has-error');
      if (errorSpan) {
        errorSpan.textContent = message;
      }
    }

    function clearError(input) {
      if (!input) return;
      var group = input.closest('.form-field-group');
      if (!group) return;
      var errorSpan = group.querySelector('.form-field-error');
      input.classList.remove('is-invalid');
      group.classList.remove('has-error');
      if (errorSpan) {
        errorSpan.textContent = '';
      }
    }

    function validateName() {
      if (!nameInput) return true;
      var val = nameInput.value.trim();
      var alphaRegex = /^[A-Za-z\s'\-]+$/;
      if (val === '') {
        showError(nameInput, 'Please enter your name.');
        return false;
      } else if (!alphaRegex.test(val)) {
        showError(nameInput, 'Name can only contain alphabetic characters.');
        return false;
      } else if (val.length < 2) {
        showError(nameInput, 'Name must be at least 2 characters long.');
        return false;
      }
      clearError(nameInput);
      return true;
    }

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        var cleanValue = this.value.replace(/[^A-Za-z\s'\-]/g, '');
        if (this.value !== cleanValue) {
          this.value = cleanValue;
        }
      });
    }

    function validateEmail() {
      if (!emailInput) return true;
      var val = emailInput.value.trim();
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (val === '') {
        showError(emailInput, 'Please enter your email address.');
        return false;
      } else if (!emailRegex.test(val)) {
        showError(emailInput, 'Please enter a valid email address (e.g. name@example.com).');
        return false;
      }
      clearError(emailInput);
      return true;
    }

    function validatePhone() {
      if (!phoneInput) return true;
      var val = phoneInput.value.trim();
      if (val === '') {
        clearError(phoneInput);
        return true; // Phone is optional
      }
      var phoneRegex = /^[0-9\+\-\s\(\)]{7,20}$/;
      var digitsOnly = val.replace(/\D/g, '');
      if (!phoneRegex.test(val) || digitsOnly.length < 7) {
        showError(phoneInput, 'Please enter a valid phone number.');
        return false;
      }
      clearError(phoneInput);
      return true;
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', function () {
        var cleanValue = this.value.replace(/[^0-9\+\-\s\(\)]/g, '');
        if (this.value !== cleanValue) {
          this.value = cleanValue;
        }
      });
    }

    function validateMessage() {
      if (!messageInput) return true;
      var val = messageInput.value.trim();
      if (val === '') {
        showError(messageInput, 'Please enter your message.');
        return false;
      } else if (val.length < 5) {
        showError(messageInput, 'Message must be at least 5 characters long.');
        return false;
      }
      clearError(messageInput);
      return true;
    }

    var inputs = [nameInput, emailInput, phoneInput, messageInput].filter(Boolean);
    inputs.forEach(function (input) {
      input.addEventListener('blur', function () {
        if (formSubmitted || input.value.trim() !== '') {
          if (input === nameInput) validateName();
          if (input === emailInput) validateEmail();
          if (input === phoneInput) validatePhone();
          if (input === messageInput) validateMessage();
        }
      });

      input.addEventListener('input', function () {
        if (formSubmitted || input.classList.contains('is-invalid')) {
          if (input === nameInput) validateName();
          if (input === emailInput) validateEmail();
          if (input === phoneInput) validatePhone();
          if (input === messageInput) validateMessage();
        }
      });
    });

    form.addEventListener('submit', function (e) {
      formSubmitted = true;
      var isNameValid = validateName();
      var isEmailValid = validateEmail();
      var isPhoneValid = validatePhone();
      var isMessageValid = validateMessage();

      if (!isNameValid || !isEmailValid || !isPhoneValid || !isMessageValid) {
        e.preventDefault();
        e.stopPropagation();
        var firstInvalid = form.querySelector('.is-invalid');
        if (firstInvalid) {
          firstInvalid.focus();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormValidation);
  } else {
    initFormValidation();
  }
})();
